import { useState, useEffect } from 'react';

// A two digit timer mm : ss
export const useTimer = (timeInSeconds) => {
  const [timerRemainingInSeconds, setTimerRemainingInSeconds] = useState(timeInSeconds);
  const getTwoDigitTimeLeft = (timeLeft) => {
    if (timeLeft < 0) {
      timeLeft = 0;
    }
    if (timeLeft < 10) {
      return `0${timeLeft}`;
    } else {
      return `${timeLeft}`;
    }
  };
  const getTimerString = () => {
    const minutesLeft = getTwoDigitTimeLeft(Math.floor(timerRemainingInSeconds / 60));
    const secondsLeft = getTwoDigitTimeLeft(timerRemainingInSeconds % 60);
    return `${minutesLeft}m: ${secondsLeft}s`;
  };
  useEffect(() => {
    if (timerRemainingInSeconds > 0) {
      setTimeout(() => {
        setTimerRemainingInSeconds((timeInSeconds) => timeInSeconds - 1);
      }, 1000);
    }
  }, [timerRemainingInSeconds]);
  return {
    timerString: getTimerString(),
    timerExpired: timerRemainingInSeconds <= 0
  };
};

export default useTimer;
